import { render, staticRenderFns } from "./EmailSideBar.vue?vue&type=template&id=75a5c2c2&scoped=true"
import script from "./EmailSideBar.vue?vue&type=script&lang=js"
export * from "./EmailSideBar.vue?vue&type=script&lang=js"
import style0 from "./EmailSideBar.vue?vue&type=style&index=0&id=75a5c2c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a5c2c2",
  null
  
)

export default component.exports